import v100 from 'src/components/forms/schemas/eventResult/telehealthWrapUp/1.0.0';
import v110 from 'src/components/forms/schemas/eventResult/telehealthWrapUp/1.1.0';

export default {
  '1.0.0': v100,
  '1.1.0': v110,
  latest: v110,
};
